import React from 'react'
import { Modal } from '@enamelai/design-system'

type ChartingResetChartModalProps = {
  show: boolean
  onCancel: () => void
  onReset: () => void
}

const ChartingResetChartModal: React.FC<ChartingResetChartModalProps> = ({
  show,
  onCancel,
  onReset,
}) => (
  <Modal
    open={show}
    onClose={onCancel}
    size="xs"
    title="Reset chart"
    description={[
      'Resetting will remove any ongoing updates.',
      'Do you want to proceed?',
    ]}
    primaryLabel="Reset"
    secondaryLabel="Cancel"
    primaryDestructive
    onPrimaryClick={onReset}
    onSecondaryClick={onCancel}
  />
)

export default ChartingResetChartModal
